import api from '../axiosConfig';

const API_URL = '/api/stock'; 

export const fetchStocks = () => api.get(API_URL);
export const createStock = (data) => api.post(API_URL, data);
export const updateStock = (id, data) => api.put(`${API_URL}/${id}`, data);
export const deleteStock = (id) => api.delete(`${API_URL}/${id}`);
